var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AsyncStorage {
    constructor(storage = localStorage) {
        this.storage = storage;
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = this.storage.getItem(key);
            // @ts-ignore
            if (!value)
                return null;
            return JSON.parse(value);
        });
    }
    remove(key) {
        return __awaiter(this, void 0, void 0, function* () {
            this.storage.removeItem(key);
        });
    }
    set(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.storage.setItem(key, JSON.stringify(value));
        });
    }
}
